import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useUIStore = create(
  persist(
    (set, get) => ({
      // Sidebar state
      isSidebarOpen: true,
      isMobileDrawerOpen: false,
      toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
      toggleMobileDrawer: () => set((state) => ({ isMobileDrawerOpen: !state.isMobileDrawerOpen })),
      setIsSidebarOpen: (value) => set({ isSidebarOpen: value }),
      setIsMobileDrawerOpen: (value) => set({ isMobileDrawerOpen: value }),
      
      // View state
      isChatView: false,
      isSettingsView: false,
      setIsChatView: (value) => set({ isChatView: value }),
      setIsSettingsView: (value) => set({ isSettingsView: value }),
      
      // Vehicle form modal
      isVehicleFormOpen: false,
      vehicleToEdit: null,
      openVehicleForm: (vehicle = null) => set({ isVehicleFormOpen: true, vehicleToEdit: vehicle }),
      closeVehicleForm: () => set({ isVehicleFormOpen: false, vehicleToEdit: null }),
      setVehicleToEdit: (vehicle) => set({ vehicleToEdit: vehicle }),
    }),
    {
      name: 'ui-storage',
      partialize: (state) => ({ isSidebarOpen: state.isSidebarOpen }),
    }
  )
);


